// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__6+yKQ","MenuIcon":"Header_MenuIcon__mU+VB","Icon":"Header_Icon__CXOja"};